export const initShieldedSite = () => {
  // eslint-disable-next-line func-names
  window.onload = function () {
    // eslint-disable-next-line new-cap, no-undef
    const frameName = new ds07o6pcmkorn({
      openElementId: '#shielded-logo',
      modalID: 'modal',
    });
    frameName.init();
  };
};

export default 'initShieldedSite';
